module.exports = __webpack_public_path__ + "static/bg-header-constructions-85bf517694dce02192ca2e7df2a13b64.svg";